import {splitIntoEqualLines} from "../split-string-to-equal-length-lines";

export default function (mortgage, config) {
    const map = {}
    const fill = {}
    const ask = []
    const errors = []
    const accountDetails = JSON.parse(mortgage.requirement.ddBankAccountDetails || '{}')
    console.log('accountDetails', accountDetails)


    //name
    fill['Text Field 157'] = {string:accountDetails.name||''}

    //address
    const lines = splitIntoEqualLines(accountDetails.address||'')
    fill['Text Field 158'] = {string: lines[0] || ''}
    fill['Text Field 159'] = {string: lines[1] || ''}
    //post code
    fill['Text Field 160'] = {string: accountDetails.postCode||''}

    // country
    fill['Text Field 161'] = {string: accountDetails.country || 'Ireland'}

    //iban
    fill['Text Field 162'] = {string: accountDetails.iban.toUpperCase().replace(/\s+/g, '')}

    //bic
    fill['Text Field 184'] = {string: (accountDetails.bic || '').toUpperCase().replace(/\s+/g, '')}

    //account Number
    fill['Text Field 207'] = {string: (mortgage.activeSubmission.mortgageAccountNo||'').replace(/\s+/g, '').slice(-7)}

    if (!mortgage.requirement?.preferredMortgagePaymentDay){
        ask.push({
            label: 'Repayment Day of Month (eg 02, 10, 31)',
            name: 'pay-day',
            type: 'TEXT',
            group: 'DD'
        })
        if (config.hasOwnProperty('pay-day')){
            fill['Text Field 2014'] = {string: config['pay-day']}
        }
        else{
            errors.push('No Repayment Day Set - Set in config')
        }
    }
    else{
        fill['Text Field 2014'] = {string: String(mortgage.requirement.preferredMortgagePaymentDay).padStart(2, '0')}
    }

    map['recurrent'] = true
    return {sections:[{map, fill, ask, errors}]}
}